import React from "react";
import { Link } from "react-router-dom";
import florianLogo from "../../assets/images/fl-logo.jpg";

export default function PublicMainNav() {
  const navStyle = "block text-blue-700 hover:text-blue-800 mr-6 text-sm";

  return (
    <div className="bg-white border-b border-b-gray-300 px-4 py-2 flex justify-between">
      <ul className="flex items-center ml-6">
        <li>
          <Link className={navStyle} to="/">
            <img className="block rounded w-[35px]" src={florianLogo} alt="Florian Laurent Logo" />
          </Link>
        </li>
        <li>
          <Link className={navStyle} to="/about">
            About
          </Link>
        </li>
        <li>
          <Link className={navStyle} to="/blog">
            Blog
          </Link>
        </li>
        <li>
          <Link className={navStyle} to="/pricing">
            Pricing
          </Link>
        </li>
        <li>
          <Link className={navStyle} to="/reviews">
            Reviews
          </Link>
        </li>
      </ul>
      <ul className="flex items-center mr-6">
        <li>
          <Link className={navStyle} to="/login">
            Login
          </Link>
        </li>
        <li>
          <Link className="bg-red-700 hover:bg-red-800 text-white px-4 py-2 text-sm rounded-full" to="/signup">
            Get Started
          </Link>
        </li>
      </ul>
    </div>
  );
}
